import { Environment } from './environment.model';

/** `ng serve --configuration=homologacao` / build homologacao — uses real HML API (empty lists are valid). */
export const environment: Environment = {
  production: false,
  baseUrl: 'https://homologacao.vivest.com.br',
  apiParametrizacaoUrl: 'api-parametrizacao-previdencia',
  apiInstitutoPrevidenciarioUrl: 'api-instituto-online',
  apiRequerimentoBeneficioUrl: 'api-requerimento-beneficio',
  apiGatewayPrefix: 'apis',
  secretPortal: '79f52b2cc565ef16f07d7f8f52df4ecdd7fa1923995f16333fc4b2055476a146',
  ocpApimSubscriptionKeyParametrizacao: '5ea2b4f6b8824770aa1ccca12db54d2e',
  ocpApimSubscriptionKeyRequerimento: '331d016338924744922dd8035467eab8',
  allowDevAuthBypass: false,
};
